export function CeleroSettingsCtrl (
  $state,
  $scope,
  $translate,
  Celero,
  confirm,
  messages,
  settings,
  terminals
) {
  $scope.celero    = new Celero(settings);
  $scope.settings  = settings;
  $scope.terminals = terminals;

  $scope.terminal = {
    id       : $scope.settings.tnp_terminal_id,
    name     : '',
    publicKey: $scope.settings.tnp_public_key
  };

  $scope.authorize = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', { name: 'Celero Payments' }))
    .then(() => $scope.celero.authorize())
    .then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', { name: 'Celero Payments' }), 'success');

      $state.reload();
    })
    .catch(error => {
      messages.error(error);
    });
  };

  $scope.save = function (form) {
    $scope.celero.saveSettings($scope.terminal)
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');

      $state.reload();
    })
    .catch(error => {
      messages.error(error);
    });
  };

  $scope.submitApiKey = function () {
    $scope.celero.setApiKey()
    .then(() => {
      messages.show($translate.instant('COMPANY_SPACE.INTEGRATIONS.CELERO.API_KEY_SAVED'), 'success');

      $state.reload();
    })
    .catch(error => {
      messages.error(error);
    });
  };

  $scope.unauthorize = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.DEACTIVATE', { name: 'Celero Payments' }))
    .then(() => $scope.celero.unauthorize())
    .then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.DEACTIVATED', { name: 'Celero Payments' }), 'success');

      $state.reload();
    })
    .catch(error => {
      messages.error(error);
    });
  };
}